import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  return <div className="text-center mb-8" data-id="element-68">
      <div className="flex items-center justify-center gap-2 mb-4" data-id="element-69">
        <Clock className="w-6 h-6 text-emerald-600" data-id="element-70" />
        <p className="text-xl font-semibold text-slate-700" data-id="element-71">
          Esta oferta termina en:
        </p>
      </div>
      <div className="flex items-center justify-center gap-3" data-id="element-72">
        <div className="bg-slate-900 text-white rounded-xl p-4 min-w-[80px]" data-id="element-73">
          <div className="text-4xl font-bold" data-id="element-74">{pad(timeLeft.hours)}</div>
          <div className="text-sm text-slate-400 mt-1" data-id="element-75">Horas</div>
        </div>
        <div className="text-3xl font-bold text-slate-900" data-id="element-76">:</div>
        <div className="bg-slate-900 text-white rounded-xl p-4 min-w-[80px]" data-id="element-77">
          <div className="text-4xl font-bold" data-id="element-78">{pad(timeLeft.minutes)}</div>
          <div className="text-sm text-slate-400 mt-1" data-id="element-79">Minutos</div>
        </div>
        <div className="text-3xl font-bold text-slate-900" data-id="element-80">:</div>
        <div className="bg-slate-900 text-white rounded-xl p-4 min-w-[80px]" data-id="element-81">
          <div className="text-4xl font-bold" data-id="element-82">{pad(timeLeft.seconds)}</div>
          <div className="text-sm text-slate-400 mt-1" data-id="element-83">Segundos</div>
        </div>
      </div>
    </div>;
}